import './style.css';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import localStorage from '../../../../utils/localStorage';
import StyledTable from "../../../../commons/styles/table";
import { StyledAddButton } from './styles';
import { Upload, message, Row, Col, Typography } from 'antd';
import { DownOutlined, InboxOutlined } from '@ant-design/icons';
import { API_DOWNLOAD, IPAddress, MAXIMOASSET } from '../../../../commons/api';

const AssetMapping = () => {
  const [fileName, setFileName] = useState('');
  const [DataSource, setDataSource] = useState([]);
  
  useEffect(() => {
    getFile();
    getAssetMappingList();
  }, []);

  const getFile = () => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const headers = {
      method: 'GET',
      url: `${MAXIMOASSET.Download}?SiteId=${siteId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    };

    axios(headers)
      .then((response) => {
        setFileName(response.data.file);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getAssetMappingList = () => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const headers = {
      method: 'GET',
      url: `${MAXIMOASSET.List}?SiteId=${siteId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    };

    axios(headers)
      .then((response) => {
        setDataSource(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
 
  const beforeUpload = (file) => {
    const isLt2M = file.size / 1024 / 1024 < 10;
    const isCSV =
      file.type === 'text/csv' ||
      file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
      file.type === 'application/vnd.ms-excel';
    if (!isCSV) {
      message.error('You can only upload CSV file!');
    }
    if (!isLt2M) {
      message.error('CSV file must be smaller than 10MB!');
    }
    return isLt2M && isCSV;
  };

  const handleChange = (info) => {
    const { status } = info.file;
    if (status === 'done') {
      message.success(`${info.file.name} file uploaded successfully.`);
    } else if (status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  };

  const AssetColumn = [
    {
      title: 'Id',
      dataIndex: 'Id',
      key: 'Id'
    },
    {
      title: 'Device',
      dataIndex: 'Device',
      key: 'Device'
    },
    {
      title: 'Asset',
      dataIndex: 'Asset',
      key: 'Asset'
    }
  ];

  const token = localStorage.get('accessToken');
  const Authorization = 'Bearer ' + token;
  const siteId = localStorage.get('currentSite');

  return (
    <div className="EAMForm">
      <Row>
        <Col span={10}>
          <div style={{ fontWeight: 'bold',  marginLeft: '5%' }}>
            File Download
          </div>
          <div className="ant-divider ant-divider-horizontal" role="separator"></div>
          {fileName ? (
            <a href={`${IPAddress.LOCAL}${API_DOWNLOAD.DownLoads}/${fileName}`}>
              <StyledAddButton type="primary">
                <DownOutlined /> {fileName}
              </StyledAddButton>
            </a>
          ) : (
            <StyledAddButton>No Files</StyledAddButton>
          )}
        </Col>
        <Col offset={1} span={12}>
          <div style={{ fontWeight: 'bold' }}>
            File Upload
          </div>
          <div className="ant-divider ant-divider-horizontal" role="separator"></div>
          <div className="antUpload">
            <Upload.Dragger
              name="file"
              accept=".csv"
              action={`${MAXIMOASSET.Upload}?SiteId=${siteId}`}
              headers={{
                Authorization: Authorization
              }}
              multiple={false}
              beforeUpload={beforeUpload}
              onChange={handleChange}
            >
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">Click or drag file to this area to upload</p>
              <p className="ant-upload-hint">1. Your can only upload .CSV file</p>
              <p className="ant-upload-hint">2. File should be less than 10MB</p>
            </Upload.Dragger>
          </div>
        </Col>
      </Row>

      <div style={{ marginTop: '2%' }}>
        <Typography.Title
          level={5}
          style={{ margin: 0, borderBottom: '1px solid #fff' }}
        >
          Asset List
        </Typography.Title>

        <div className="ant-divider ant-divider-horizontal" role="separator"></div>
        <StyledTable size="small"
          columns={AssetColumn}
          
          pagination={
            DataSource.length > 10
              ? {
                pageSize: '10'
              }
              : false
          }
          dataSource={DataSource.map((data, index) => ({ ...data, key: index }))}
        />
      </div>
    </div>
  );
};

export default AssetMapping;
